import client from '../client.js'
import destroyClientGql from '../mutations/destroy-client.gql'

const destroyClient = (input) => {
  return client.mutate({
    mutation: destroyClientGql,
    variables: input,
    update: (store, { data }) => {
      // This is intentional
    }
  })
}

export default destroyClient
